import type { FC } from "react";
import HeadsUpEmptyStateIllustrationLight from "@/assets/images/heads-up-empty-state-illustration-light.svg";
import HeadsUpEmptyStateIllustrationDark from "@/assets/images/heads-up-empty-state-illustration-dark.svg";
import { HeadsUpStateText, StateWrapper } from "./shared";
import styled from "@emotion/styled";
import { useTheme } from "@/mds";

export const HeadsUpFullEmptyView: FC = () => {
  const { themeType } = useTheme();

  const illustrationSrc =
    themeType === "harvest"
      ? HeadsUpEmptyStateIllustrationLight
      : HeadsUpEmptyStateIllustrationDark;

  return (
    <StateWrapper>
      <StyledEmptyStateIllustration src={illustrationSrc} alt="No content" />
      <HeadsUpStateText as="p">
        Open a note to see Heads Up find connections to your other thoughts
      </HeadsUpStateText>
    </StateWrapper>
  );
};

export const StyledEmptyStateIllustration = styled.img`
  height: 164px;
  margin-top: 24px;
  margin-bottom: 12px;
`;
